import { render, staticRenderFns } from "./index.vue?vue&type=template&id=57aee1b2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=57aee1b2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57aee1b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JNproject\\qbyfdq-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57aee1b2')) {
      api.createRecord('57aee1b2', component.options)
    } else {
      api.reload('57aee1b2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=57aee1b2&scoped=true", function () {
      api.rerender('57aee1b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PDFViewer/index.vue"
export default component.exports